var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHalfEllipse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 654,
    viewBox: "0 0 162 654",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162 327C162 507.597 15.5971 654 -165 654C-345.597 654 -492 507.597 -492 327C-492 146.403 -345.597 0 -165 0C15.5971 0 162 146.403 162 327ZM-377.799 327C-377.799 444.525 -282.525 539.799 -165 539.799C-47.4745 539.799 47.7986 444.525 47.7986 327C47.7986 209.475 -47.4745 114.201 -165 114.201C-282.525 114.201 -377.799 209.475 -377.799 327Z",
    fill: "#F5FAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfEllipse);
export default __webpack_public_path__ + "static/media/half-ellipse.08ec7f14cb01c77d655c2e22b4aaf1c1.svg";
export { ForwardRef as ReactComponent };